import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UserAgentService } from '../../services/user-agent.service';

@Injectable({
  providedIn: 'root',
})
export class MobileRestrictedGuard {
  constructor(
    private readonly userAgentService: UserAgentService,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
  ) {}

  canMatch(_route: Route, segments: UrlSegment[]): boolean | UrlTree {
    if (this.userAgentService.isXSmall) {
      const accountId = segments[0]?.path ?? this.authService.getCurrentAccount()?.accountUID;
      return accountId ? this.router.createUrlTree([`/${accountId}/events`]) : false;
    }
    return true;
  }
}
